
// export const dynamic = 'force-dynamic'
import cl from "@/utils/console/cl";
import urls from "@/utils/urls/urls";
import Link from "next/link";
import NavbarMobile from "./NavbarMobile";
import GoogleTranslate from "@/components/GoogleTranslate/GoogleTranslate";
import TranslateOnRouteChange from "@/components/GoogleTranslate/TranslateOnRouteChange";


export default async function Navbar() {


    const resSetting = await fetch(urls?.setting)
    const dataSetting = await resSetting.json()

    const settings = dataSetting?.data[0];
    // cl("settings", settings)
    // console.log("settings", settings)

    const resMenu = await fetch(urls?.menu)
    const dataMenu = await resMenu.json()
    // cl("menuItems", data.data?.menu_items)
    const resFooter = await fetch(urls?.footer)
    const dataFooter = await resFooter.json()
    const footerData = dataFooter?.data[0];
    // cl("footerData", footerData)

    const resProductCategory = await fetch(urls?.productCategory)
    const dataProductCategory = await resProductCategory.json()


    const menuData = dataMenu?.data;
    return (
        <>
            <header className="header"
            >
                {/* header top */}
                <div className="header-top"

                >

                    {/* <div className="shape">
                        <div className="shape-1" />
                        <div className="shape-2" />
                    </div> */}
                    <div className="container pe-0">
                        <div className="header-top-wrap">
                            <div className="header-top-left">
                                <div className="header-top-list">
                                    <ul>
                                        {/* <li><Link href="https://live.themewild.com/cdn-cgi/l/email-protection#e68f888089a6839e878b968a83c885898b"><i className="far fa-envelopes"></i>
                                  <span className="__cf_email__" data-cfemail="84edeae2ebc4e1fce5e9f4e8e1aae7ebe9">[email&#160;protected]</span></Link></li> */}
                                        {/* <li>
                                            <Link href={`mailto:${footerData?.email}`}>
                                                <i className="far fa-envelopes" />
                                                {footerData?.email}
                                            </Link>
                                        </li> */}
                                        {/* <li>
                                            <Link href={`tel:${footerData?.mobile}`}>
                                                <i className="far fa-phone-volume" />
                                                {footerData?.mobile}
                                            </Link>
                                        </li> */}
                                        <li>
                                            <Link href="#">
                                                <i className="far fa-alarm-clock" /> {footerData?.openhours}
                                            </Link>
                                        </li>
                                        <li>
                                            <header>
                                                <GoogleTranslate />
                                                <TranslateOnRouteChange />
                                            </header>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="header-top-right">
                                <div className="header-top-list">
                                    {/* <Link href="login"><i className="far fa-sign-in"></i> Login</Link> */}
                                </div>
                                <div className="header-top-lang">
                                    {/* <div className="dropdown">
                                                 <Link href="#" className="top-lang dropdown-toggle" data-bs-toggle="dropdown"><i
                                                         className="fal fa-globe"></i> Eng</Link>
                                                 <ul className="dropdown-menu dropdown-menu-end">
                                                     <li><Link className="dropdown-item" href="#">English</Link></li>
                                                     <li><Link className="dropdown-item" href="#">German</Link></li>
                                                     <li><Link className="dropdown-item" href="#">Russian</Link></li>
                                                     <li><Link className="dropdown-item" href="#">Spanish</Link></li>
                                                 </ul>
                                             </div>
                                         </div> */}
                                    <div className="header-top-social">
                                        <span>Follow Us: </span>
                                        {
                                            footerData?.social_icons &&
                                            footerData?.social_icons?.map((icon: any, index: any) => (
                                                <Link href={icon?.link} target="_blank" key={index}>
                                                    <i className={`fab ${icon?.icon}`}></i>
                                                </Link>
                                            ))
                                        }
                                        {/* <Link href="#">
                                            <i className="fab fa-facebook" />
                                        </Link>
                                        <Link href="#">
                                            <i className="fab fa-x-twitter" />
                                        </Link>
                                        <Link href="#">
                                            <i className="fab fa-instagram" />
                                        </Link>
                                        <Link href="#">
                                            <i className="fab fa-linkedin" />
                                        </Link> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* header top end */}
                    {/* navbar */}

                    <NavbarMobile propsData={{ menuData, settings, dataProductCategory }} />
                    {/* navbar end*/}
                </div>
            </header>

        </>
    )
}



// export default Navbar
// {
//     menuData?.menu_items &&
//     menuData?.menu_items?.map((menuItem, index) => (
//         // <li key={index} className="menu-item-has-children">
//         <li key={index}
//             className="nav-item"
//             style={{
//                 // border: '1px solid red',
//                 margin: '0px',
//                 padding: '0px'

//             }}
//         >
//             {menuItem?.subMenuItems?.length > 0 ? (
//                 <>
//                     {/* <li key={index} > */}
//                     <Link href={menuItem?.url_slug} className=" fs-6" style={{ textDecoration: 'none' }}>
//                         {menuItem?.menu_level} {" "}
//                         <span className="plus-animation"></span>
//                         {/* <i class="bi bi-plus-lg"></i> */}
//                         {/* <i className="bi bi-plus-lg dropdown-icon" /> */}
//                         {/* <i class="bi bi-plus-lg"></i> */}
//                     </Link>
//                     {/* <i className="bi bi-plus dropdown-icon" /> */}

//                     <ul className="sub-menu">
//                         {
//                             menuItem?.subMenuItems &&
//                             menuItem?.subMenuItems?.map((subItem, subIndex) => (
//                                 <li key={subIndex}>
//                                     <Link key={subIndex} href={subItem?.url_slug} style={{ textDecoration: 'none' }}>
//                                         {subItem?.menu_level}

//                                     </Link>
//                                 </li>
//                             ))}
//                     </ul>
//                     {/* </li> */}
//                 </>
//             ) : (
//                 <Link href={menuItem?.url_slug} style={{ textDecoration: 'none' }}>
//                     {menuItem?.menu_level}
//                 </Link>
//             )}
//         </li>
//     ))}